<template>
  <div class="format-change-wrapper">
    <h6 class="format-change-header flex items-center">
      HR 推荐模板样式
      <img class="vip" src="https://logo.wondercv.com/banners/OhqGtgp8NRmSYY7.svg" alt="" />
    </h6>
    <div class="template-tab-list flex items-center">
      <div
        v-for="(item, index) in TEMPLATE_TYPE"
        :key="index"
        class="template-tab-item"
        :class="{ active: activeType === item.type }"
        @click="clickTemplateTypeItem(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="template-style-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="template-img-wrapper"
        :class="{
          active: activeImage === item.imgSrc || cvDetail.format_info.template_type === item.imgSrc,
        }"
      >
        <div class="template-img-container flex items-start relative">
          <div v-if="item.vipType === 'forever'" class="forever-vip-tag flex justify-center items-center">
            <img src="https://logo.wondercv.com/banners/9rwrIGmNlvt3SIL.svg" alt="" />
            <span>终身VIP</span>
          </div>
          <img
            class="template-style-item"
            :src="item.imgSrc"
            alt=""
            @click="clickTemplateItem(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import recommendTemplateStyle from '@/assets/json/recommend-template-style.json';
import { formatOperationMixin } from '@/views/editor2025/mixins/format-operation';
import { styleMixin } from '@/assets/js/mixins';

const TEMPLATE_TYPE = [
  {
    type: '',
    name: '全部',
  },
  {
    type: 'recommend',
    name: '推荐',
  },
  {
    type: 'professional',
    name: '专业',
  },
  {
    type: 'classic',
    name: '经典',
  },
  {
    type: 'simple',
    name: '简约',
  },
];

export default {
  name: 'ResumeFormatChange',
  mixins: [styleMixin, formatOperationMixin],
  data() {
    return {
      tempStyleList: recommendTemplateStyle['editor_2025'],
      TEMPLATE_TYPE,
      activeType: '',
      activeImage: '',
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'profile']),
    list() {
      return this.tempStyleList.filter((item) => {
        return !this.activeType || item.type === this.activeType;
      });
    },
  },
  methods: {
    clickTemplateTypeItem(item) {
      this.activeType = item.type;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.format-change-wrapper {
  width: 574px;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
  height: 100%;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .format-change-header {
    color: $text-color;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    width: fit-content;
    img {
      width: 18px;
      height: 18px;
      margin-left: 12px;
    }
  }
  .template-tab-list {
    gap: 24px;
    margin-bottom: 16px;
    border-bottom: 1px solid #2e3239;
    .template-tab-item {
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      color: #8b95a7;
      padding-bottom: 8px;
      &.active {
        @apply relative;
        color: $theme-color;
        font-weight: 600;
        &::after {
          content: '';
          display: inline-block;
          width: 100%;
          height: 2px;
          background-color: $theme-color;
          position: absolute;
          bottom: -1px;
          left: 0;
        }
      }
    }
  }
  .template-style-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 32px;
    .template-img-wrapper {
      .template-img-container {
        display: flex;
        align-items: flex-start;
        width: 167px;
        height: 234px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 6px;
        img {
          width: 100%;
          object-fit: cover;
          vertical-align: top;
        }
        .forever-vip-tag {
          position: absolute;
          top: 0;
          right: 0;
          width: 75px;
          height: 24px;
          border-radius: 0px 6px 0px 12px;
          background: linear-gradient(88deg, #ebba77 0.6%, #f4d0a4 46.21%, #ebba77 98.55%);
          box-shadow: -2px 4px 4px 0px rgba(206, 177, 147, 0.25) inset;
          font-size: 12px;
          color: #0f1023;
          font-weight: 500;
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
      }
      &.active {
        @apply relative;
        .template-img-container {
          position: relative;
          z-index: 2;
          background-color: $page-bg-sub-color;
          border-radius: 6px;
          overflow: hidden;
          img {
            border-radius: 6px;
          }
        }
        &::after {
          content: '';
          display: inline-block;
          width: calc(100% + 10px);
          height: calc(100% + 10px);
          border: 3px solid $theme-color;
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          border-radius: 8px;
        }
      }
    }
    // .template-style-item {
    //   cursor: pointer;

    //   border-radius: 6px;
    //   // &.active,
    //   // &:hover {
    //   //   // border-color: #4183ff;
    //   // }
    // }
  }
}
</style>
